module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgContent"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "show-message": false,
      "rules": _vm.rules
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("建筑物名称")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "buildingName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入楼宇名称"
    },
    model: {
      value: (_vm.params.buildingName),
      callback: function($$v) {
        _vm.$set(_vm.params, "buildingName", $$v)
      },
      expression: "params.buildingName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("物业单位")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "tenement"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入物业单位"
    },
    model: {
      value: (_vm.params.tenement),
      callback: function($$v) {
        _vm.$set(_vm.params, "tenement", $$v)
      },
      expression: "params.tenement"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("产权单位")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "propertyUnit"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入产权单位"
    },
    model: {
      value: (_vm.params.propertyUnit),
      callback: function($$v) {
        _vm.$set(_vm.params, "propertyUnit", $$v)
      },
      expression: "params.propertyUnit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName locSet"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("地址")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "prop": "address"
    }
  }, [_c('ads-select', {
    attrs: {
      "adsList": _vm.adsStore,
      "selectType": "1"
    },
    on: {
      "selected": _vm.mapChange
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("所属街乡")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "jiexiangId"
    }
  }, [_c('tree-select', {
    attrs: {
      "code": "szjx",
      "selectId": _vm.params.jiexiangId,
      "moreSelect": false,
      "paramsKey": "jiexiang",
      "plaText": "所在街乡"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("所属功能区")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "parkId"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "parkId"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "ssgnyq",
      "selectId": _vm.params.parkId,
      "paramsKey": "park",
      "plaText": "请输入所属功能区"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("项目类型")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "projectTypeId"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "xmlx",
      "selectId": _vm.params.projectTypeId,
      "paramsKey": "projectType",
      "plaText": "请选择项目类型"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("是否国有")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "nationalizedId"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "isguoyou",
      "selectId": _vm.params.nationalizedId,
      "paramsKey": "nationalized",
      "plaText": "请选择国有类型"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("产业定位")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "locationId"
    }
  }, [_c('all-select', {
    attrs: {
      "code": "dw",
      "selectId": _vm.params.locationId,
      "paramsKey": "location",
      "plaText": "请选择产业定位"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("是否愿意在市级平台对外发布推介")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "isWillingCityPlatformReleaseRecommendId"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "isWillingCityPlatformReleaseRecommend",
      "selectId": _vm.params.isWillingCityPlatformReleaseRecommendId,
      "paramsKey": "isWillingCityPlatformReleaseRecommend",
      "plaText": "请选择"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("是否愿意在区级招商工作中对外发布推介")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "isWillingDistrictInvestmentWorkeleaseRecommendId"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "isWillingDistrictInvestmentWorkeleaseRecommend",
      "selectId": _vm.params.isWillingDistrictInvestmentWorkeleaseRecommendId,
      "paramsKey": "isWillingDistrictInvestmentWorkeleaseRecommend",
      "plaText": "请选择"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("不希望对外发布的原因")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "notPublishReason"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入不希望对外发布的原因"
    },
    model: {
      value: (_vm.params.notPublishReason),
      callback: function($$v) {
        _vm.$set(_vm.params, "notPublishReason", $$v)
      },
      expression: "params.notPublishReason"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("是否愿意承接国际组织办公场所")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "isWillingUndertakeInterOrganizationWorkspaceId"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "isWillingUndertakeInterOrganizationWorkspace",
      "selectId": _vm.params.isWillingUndertakeInterOrganizationWorkspaceId,
      "paramsKey": "isWillingUndertakeInterOrganizationWorkspace",
      "plaText": "请选择"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("规划建筑面积(平方米)")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "planBuildingArea"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.params.planBuildingArea),
      callback: function($$v) {
        _vm.$set(_vm.params, "planBuildingArea", $$v)
      },
      expression: "params.planBuildingArea"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("当前空置可招商面积（平方米）")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "totalVacantArea"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.params.totalVacantArea),
      callback: function($$v) {
        _vm.$set(_vm.params, "totalVacantArea", $$v)
      },
      expression: "params.totalVacantArea"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("招商负责人")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "leadingCadre"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入招商负责人"
    },
    model: {
      value: (_vm.params.leadingCadre),
      callback: function($$v) {
        _vm.$set(_vm.params, "leadingCadre", $$v)
      },
      expression: "params.leadingCadre"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("负责人手机号")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "leadingCadrePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入负责人手机号"
    },
    model: {
      value: (_vm.params.leadingCadrePhone),
      callback: function($$v) {
        _vm.$set(_vm.params, "leadingCadrePhone", $$v)
      },
      expression: "params.leadingCadrePhone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "inpItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("负责人邮箱")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "leadingCadreEmail"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入负责人邮箱"
    },
    model: {
      value: (_vm.params.leadingCadreEmail),
      callback: function($$v) {
        _vm.$set(_vm.params, "leadingCadreEmail", $$v)
      },
      expression: "params.leadingCadreEmail"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "textItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 12,
      "xl": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', [_vm._v("周边交通情况")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "trafficCondition"
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 3,
      "type": "textarea",
      "size": "medium",
      "placeholder": "例：距离XX公交站500米，XX地铁站700米，四环路1公里，XX高速2.5公里"
    },
    model: {
      value: (_vm.params.trafficCondition),
      callback: function($$v) {
        _vm.$set(_vm.params, "trafficCondition", $$v)
      },
      expression: "params.trafficCondition"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "textItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 12,
      "xl": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', [_vm._v("周边公共配套情况")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "supportingSituation"
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 3,
      "type": "textarea",
      "size": "medium",
      "placeholder": "请输入商业、餐饮、绿化等配套设施"
    },
    model: {
      value: (_vm.params.supportingSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "supportingSituation", $$v)
      },
      expression: "params.supportingSituation"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "textItem",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 12,
      "xl": 8
    }
  }, [_c('div', {
    staticClass: "iName"
  }, [_c('span', [_vm._v("其他补充说明")])]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "other"
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 3,
      "type": "textarea",
      "size": "medium",
      "placeholder": "请输入免部分租期，车位情况，特色服务"
    },
    model: {
      value: (_vm.params.other),
      callback: function($$v) {
        _vm.$set(_vm.params, "other", $$v)
      },
      expression: "params.other"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgUpload"
  }, [_c('div', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "dot"
  }, [_vm._v("*")]), _vm._v("\n          上传楼宇图片（分为楼外观，大厅，室内环境，局部平面图几类上传）\n          "), _c('span', [_vm._v("只能上传jpg/jpeg/png/gif文件，且不超过 2M (115*70推荐)")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "image"
    }
  }, [_c('imgsUp', {
    attrs: {
      "files": _vm.params.image
    },
    on: {
      "fileChange": _vm.imgChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-49268110"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/industryInfos/buildingEdit/components/buildingSave.vue
// module id = 1476
// module chunks = 1